import type { UserAPI } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import { getURLParam } from '@sydle/ui-utils';
import type { ActionResult } from '@vaadin/router';

export async function validateQueryParams(): Promise<ActionResult> {
  const userAPI = getAPI<UserAPI>('userAPI');
  if (!userAPI) {
    return;
  }

  const accessToken = getURLParam('accessToken');
  if (accessToken) {
    const response = await userAPI.validateToken({ accessToken });

    if (response?.data?.accessToken?.token) {
      await userAPI.renewToken({ token: response.data.accessToken.token });
    }
  }

  const signOut = getURLParam('signOut') === 'true';
  if (signOut) {
    await userAPI.logout();
  }

  const language = getURLParam('language');
  if (language) {
    userAPI.setCurrentLanguage(language);
  }
}
